
import respUtility from '@/mixins/respUtility';
import ReviewsViewSiteRatingsListItem from './SiteRatingsList/item.vue';

export default {
  name: 'ReviewsViewSiteRatingsList',
  mixins: [respUtility],
  components: {
    ReviewsViewSiteRatingsListItem,
  },
  props: {
    siteDetails: {
      type: Array,
      required: true,
    },
  },
  computed: {
    firstThreeItems() {
      return this.siteDetails.slice(0, 3);
    },
    remainingItems() {
      return this.siteDetails.slice(3);
    },
  },
};
